<template>
  <div class="flex h-screen">
    <main class="container mx-auto">
      <slot />
    </main>
  </div>
</template>
